import { render, staticRenderFns } from "./PainelPanico.vue?vue&type=template&id=5128a384&"
import script from "./PainelPanico.vue?vue&type=script&lang=js&"
export * from "./PainelPanico.vue?vue&type=script&lang=js&"
import style0 from "./PainelPanico.vue?vue&type=style&index=0&id=5128a384&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports